// Storyblok asset filenames carry the original upload's intrinsic size as a
// path segment: `…/f/<space>/<w>x<h>/<hash>/<name>.<ext>`. Components use it to
// set width/height so the browser reserves layout space before the image
// arrives (CLS). Transform URLs (`…/m/<w>x<h>/…`) must never be passed here —
// callers parse the raw `filename`, not a transformed variant.

const SIZE_SEGMENT = /\/(\d+)x(\d+)\//

/**
 * @param {string} filename raw Storyblok asset URL
 * @returns {{ width: number, height: number } | null} null when the URL has
 * no size segment (external URLs, legacy assets) — callers omit the attrs
 * rather than render wrong ones.
 */
export default function storyblokImageSize(filename) {
    const match = SIZE_SEGMENT.exec(filename || '')
    if (!match)
        return null

    return {
        width: Number(match[1]),
        height: Number(match[2]),
    }
}
